import { render } from "./ModalUsersIpiranga.vue?vue&type=template&id=2c89a1df&scoped=true&ts=true"
import script from "./ModalUsersIpiranga.vue?vue&type=script&lang=ts"
export * from "./ModalUsersIpiranga.vue?vue&type=script&lang=ts"

import "./ModalUsersIpiranga.vue?vue&type=style&index=0&id=2c89a1df&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c89a1df"]])

export default __exports__